<template>
    <div class="buyflow-panel">
        <template v-if="onlyStreaming">
            <div class="py-2
                        flex
                        flex-col tablet:flex-row
                        gap-3 tablet:gap-4
                        justify-items-center tablet:justify-items-stretch
                        items-center"
            >
                <div>
                    <img alt="Max" class="w-52" src="/assets/images/buyflow/logo-max.png" />
                </div>
                <div class="desktop:pr-4
                            text-sm tablet:text-md
                            leading-snug
                            text-center tablet:text-left
                            my-1 tablet:my-0"
                >
                    {{ hboMax.subtitle }}
                </div>
                <div class="flex
                            flex-col
                            justify-between
                            items-center tablet:items-end"
                >
                    <PricePerMonth :price="hboMax.price" />
                    <button
                        @click="$emit('select-streaming-service', hboMax)"
                        :class="{ 'active': isPackageSelected(hboMax) }"
                        class="buyflow-button flex items-center mt-4 mobile:mt-3"
                    >
                        <template v-if="isPackageSelected(hboMax)">
                            <IconCheck class="mr-1" />
                            Added
                        </template>
                        <template v-else>
                            <IconPlus class="mr-1" />
                            Add Max
                        </template>
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="flex
                        flex-row
                        justify-between
                        items-center
                        gap-4">
                <div class="text-lg
                            font-bold">
                    No, thanks, I don't want to add TV.
                </div>
                <button type="button"
                        :disabled="hasDeclinedOrSelectedStreaming"
                        class="buyflow-button"
                        @click="$emit('decline-service', true)">
                    <template v-if="hasDeclinedOrSelectedStreaming">
                        Declined
                    </template>
                    <template v-else>
                        Decline TV
                    </template>
                </button>

            </div>

            <!-- streaming services are generic, up to this point where we extract HBOMax out -->
            <div v-if="hasDeclinedOrSelectedStreaming"
                 class="mt-4
                        bg-gray-200
                        p-4
                        rounded-md">
                <div class="text-base desktop:text-lg
                            font-bold">
                    Even without TV service, you can still stream HBO:
                </div>
                <div class="grid
                            grid-cols-6
                            justify-end
                            items-center
                            pt-4">
                    <div class="col-span-4
                                desktop:col-span-5">
                        <div class="mb-2">
                            <img alt="Max" class="w-40" src="/assets/images/buyflow/logo-max.png" />
                        </div>
                        <div class="text-sm desktop:text-base">
                            {{ hboMax.subtitle }}
                        </div>
                    </div>
                    <div class="col-span-1
                                desktop:hidden">
                    </div>
                    <div class="justify-self-end
                                text-center">
                        <div class="block
                                    mb-1
                                    whitespace-nowrap
                                    desktop:text-lg">
                            <span class="text-salmon
                                         font-bold
                                         -mx-0.5">
                                {{ toCurrency(hboMax.price) }}
                            </span>
                            <span class="text-xs desktop:text-sm">/mo</span>
                        </div>
                        <button
                            @click="$emit('select-streaming-service', hboMax)"
                            :class="{ 'active': isPackageSelected(hboMax) }"
                            class="buyflow-button flex items-center"
                        >
                            <template v-if="isPackageSelected(hboMax)">
                                <IconCheck class="mr-1" />
                                Added
                            </template>
                            <template v-else>
                                <IconPlus class="mr-1" />
                                Add
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import PricePerMonth from "../../../../components/atoms/PricePerMonth";
import IconCheck from "@/atoms/icons/IconCheck"
import IconPlus from "@/atoms/icons/IconPlus"

export default {
    name: 'TVDeclineService',
    components: {
        PricePerMonth,
        IconCheck,
        IconPlus,
    },
    props: {
        hasDeclined: {
            type: Boolean,
            required: true,
        },
        isPackageSelected: {
            type: Function,
            required: true,
        },
        onlyStreaming: {
            type: Boolean,
            default: false,
        },
        streamingServices: {
            type: Object,
            required: true,
        }
    },
    computed: {
        hboMax() {
            return this.streamingServices.hboMax
        },
        hasDeclinedOrSelectedStreaming() {
            return this.hasDeclined || this.isPackageSelected(this.hboMax)
        },
    },
}
</script>
